import configApi from '@/api/config';
import BaseService from '@/api/base.service';
import grapePerksAppService from '@/api';

/**
 * tag service api
 * @class TagService
 */
class TagService extends BaseService {
  constructor() {
    super({ baseUrl: configApi.baseRoutesUrls.tags });
  }

  getActiveImport = () => grapePerksAppService.get(
    `${this.baseUrl}/import-from-file/active-import`, { },
  ).then((resp) => resp.data);
}

const singletonInstance = new TagService();

/**
 * tag service api instance
 * @exports api/modules/audiences/tag
 * */
export default singletonInstance;
